import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

type PaginationControllerProps = {
  pageNumber: number;
  maxPageNumber: number;
  navigateNextPage: () => void;
  navigatePreviousPage: () => void;
};

export const PaginationController = ({
  pageNumber,
  maxPageNumber,
  navigateNextPage,
  navigatePreviousPage,
}: PaginationControllerProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        p: 0.5,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
      }}
    >
      <Button
        size="small"
        disabled={pageNumber <= 1}
        onClick={navigatePreviousPage}
        startIcon={<NavigateBeforeRoundedIcon />}
        sx={{
          height: 32,
          px: 1.5,
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: '8px',
          color: 'text.secondary',
          '&:hover': {
            bgcolor: 'action.hover',
            color: 'text.primary',
          },
          '&.Mui-disabled': {
            color: 'text.disabled',
          },
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          Previous
        </Box>
      </Button>

      <Box
        sx={{
          display: 'flex',
          height: 32,
          minWidth: 80,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '8px',
          bgcolor: 'action.hover',
          px: 1.5,
        }}
      >
        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'text.primary' }}>
          {maxPageNumber !== 0 ? pageNumber : 0} of {maxPageNumber}
        </Typography>
      </Box>

      <Button
        size="small"
        disabled={pageNumber >= maxPageNumber || maxPageNumber === 0}
        onClick={navigateNextPage}
        endIcon={<NavigateNextRoundedIcon />}
        sx={{
          height: 32,
          px: 1.5,
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: '8px',
          color: 'text.secondary',
          '&:hover': {
            bgcolor: 'action.hover',
            color: 'text.primary',
          },
          '&.Mui-disabled': {
            color: 'text.disabled',
          },
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          Next
        </Box>
      </Button>
    </Box>
  </Box>
);
